export const habaAltText = {
  altText: {
    emptyCart: 'Empty shopping cart – no items in your basket at HABA Play',
    orderDetailsTrack: 'Truck icon – represents standard delivery at HABA Play',
    personalizationModalPreviewImg: 'Embroidery preview',
    deliveryLogo: {
      dhl: 'DHL logo – shipping with DHL at HABA Play',
      hermes: 'Hermes logo – shipping with Hermes at HABA Play',
      default: 'Animated truck icon – represents delivery at HABA Play',
    },
    paymentLogo: {
      advancePayment: 'Prepayment icon – pay by bank transfer at HABA Play',
      ct_creditcard_hop: 'Mastercard and Visa logos – pay by credit card at HABA Play',
      ct_paypal: 'PayPal logo – secure online payment at HABA Play',
      invoice: 'Invoice icon – pay by invoice at HABA Play',
      fallback: 'Payment icon – represents secure payment at HABA Play'
    }
  },
};
